"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@iconify/react");
var _material = require("@mui/material");
var _SearchField = _interopRequireDefault(require("components/shared/SearchField/SearchField"));
var _reactRouterDom = require("react-router-dom");
var _constants = require("util/constants");
var _DocumentGrid = require("./DocumentGrid.utils");
var _DocumentGridBreadcrumb = _interopRequireDefault(require("./DocumentGridBreadcrumb"));
var _DocumentsGridSelected = _interopRequireDefault(require("./DocumentsGridSelected"));
var _usePostDownloadBlobs2 = require("@/api/usePostDownloadBlobs");
var _DocumentIcon = require("@/components/DocumentManagementView/DocumentGrid/DocumentIcon/DocumentIcon");
var _CustomGrid = _interopRequireDefault(require("@/components/shared/CustomGrid/CustomGrid"));
var _PermissionsContext = require("@/context/PermissionsContext");
var _policies = require("@/utils/policies");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DocumentsGrid = function DocumentsGrid(_ref) {
  var setSelectedPath = _ref.setSelectedPath,
    selectedPath = _ref.selectedPath,
    isDocumentsLoading = _ref.isDocumentsLoading,
    blobs = _ref.blobs,
    callbackAddFiles = _ref.callbackAddFiles,
    callbackDeleteFile = _ref.callbackDeleteFile,
    callbackEditFile = _ref.callbackEditFile,
    callbackOverrideFile = _ref.callbackOverrideFile,
    callbackMoveFiles = _ref.callbackMoveFiles,
    selectedRows = _ref.selectedRows,
    setSelectedRows = _ref.setSelectedRows;
  var _usePermissions = (0, _PermissionsContext.usePermissions)(),
    hasPermission = _usePermissions.hasPermission,
    hasAnyPermission = _usePermissions.hasAnyPermission;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    documents = _useState2[0],
    setDocuments = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    hiddenItemIds = _useState4[0],
    setHiddenItemIds = _useState4[1];
  var gridRef = (0, _react.useRef)(null);
  var _usePostDownloadBlobs = (0, _usePostDownloadBlobs2.usePostDownloadBlobs)(),
    downloadBlobs = _usePostDownloadBlobs.mutateAsync;
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    downloadLoading = _useState6[0],
    setDownloadLoading = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    downloadFromGridLoading = _useState8[0],
    setDownloadFromGridLoading = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedDocument = _useState0[0],
    setSelectedDocument = _useState0[1];
  var _useState1 = (0, _react.useState)(""),
    _useState10 = _slicedToArray(_useState1, 2),
    searchText = _useState10[0],
    setSearchText = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedButtonId = _useState12[0],
    setSelectedButtonId = _useState12[1];
  var _useState13 = (0, _react.useState)(null),
    _useState14 = _slicedToArray(_useState13, 2),
    parentId = _useState14[0],
    setParentId = _useState14[1];
  var _React$useState = _react["default"].useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchorEl = _React$useState2[0],
    setAnchorEl = _React$useState2[1];
  var setLocalStorage = function setLocalStorage(row) {
    localStorage.setItem("doc-".concat(row.id), JSON.stringify(row));
  };
  var theme = (0, _material.useTheme)();
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    gridRows = _useState16[0],
    setGridRows = _useState16[1];
  (0, _react.useEffect)(function () {
    if (gridRows.length === 0 && searchText === "") {
      setSelectedPath(selectedPath.slice(0, -1));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gridRows]);
  (0, _react.useEffect)(function () {
    var allGridRows = documents.filter(function (b) {
      return b.parentId === parentId;
    });
    var rowsForGrid = searchText ? allGridRows.filter(function (file) {
      return file.documentName.toLowerCase().includes(searchText.toLowerCase());
    }) : allGridRows;
    setGridRows(rowsForGrid);
  }, [documents, parentId, searchText]);
  var getNonFolderItems = function getNonFolderItems(items) {
    return items.filter(function (i) {
      return i.fileType !== _constants.TYPE_FOLDER;
    });
  };
  var columns = [{
    renderCell: function renderCell(params) {
      var indexingStatus = _constants.INDEXING_STATUSES[params.row.indexing_status];
      return /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
        title: params ? params.row.documentName : null,
        arrow: true
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "flex align-items-center gap-8"
      }, /*#__PURE__*/_react["default"].createElement(_DocumentIcon.DocumentIcon, {
        fileType: params.row.fileType
      }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        style: {
          color: theme.palette.primary.main,
          textDecoration: "none",
          maxWidth: "80%"
        },
        "data-testid": "link-".concat(params.row.documentName),
        className: "text-overflow-ellipsis",
        to: "/document-viewer?id=".concat(params.row.id),
        onClick: function onClick(e) {
          if (params.row.fileType == _constants.TYPE_FOLDER) {
            e.preventDefault();
          }
          handleColumnNameClick(params.row);
        },
        onContextMenu: function onContextMenu(e) {
          if (params.row.fileType == _constants.TYPE_FOLDER) {
            e.preventDefault();
          } else {
            handleColumnNameClick(params.row);
          }
        },
        onMouseDown: function onMouseDown(e) {
          if (e.button === 1) {
            // Detection of the mouse scroll button
            handleColumnNameClick(params.row);
          }
        },
        target: "_blank"
      }, params.row.documentName), params.row.source === _constants.SOURCE_TEAMS && /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
        icon: "logos:microsoft-teams",
        width: 15,
        height: 15
      }), (params.row.indexing_status === "IN_PROGRESS" || params.row.indexing_status === "ERROR") && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_material.Divider, {
        orientation: "vertical",
        style: {
          height: 20
        }
      }), " ", indexingStatus)));
    },
    headerName: "Document name",
    flex: 1.5,
    field: "documentName",
    sortable: true
  }, {
    field: "category",
    headerName: "Category",
    flex: 1,
    sortable: true,
    filterable: true
  }, {
    field: "fileType",
    headerName: "Type",
    flex: 1,
    renderCell: function renderCell(params) {
      return /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "fileType_bullet_container"
      }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
        className: "fileType_bullet ".concat(params.row.fileType == _constants.TYPE_FOLDER ? "folder" : "file")
      }, params.row.fileType));
    },
    sortable: true,
    filterable: true
  }, {
    field: "source",
    headerName: "Source",
    flex: 1,
    sortable: true,
    filterable: true
  }, {
    field: "uploaded",
    headerName: "Uploaded",
    flex: 1,
    sortable: true
  }, {
    field: "uploadedBy",
    headerName: "Uploaded by",
    flex: 1,
    sortable: true,
    filterable: true
  }];
  // Use ref to track if we're updating selection internally to prevent loops
  var isUpdatingSelectionRef = (0, _react.useRef)(false);
  var previousBlobsRef = (0, _react.useRef)(undefined);
  (0, _react.useEffect)(function () {
    setSearchText("");
    if (blobs && blobs !== previousBlobsRef.current) {
      previousBlobsRef.current = blobs;
      var newDocuments = (0, _DocumentGrid.getBlobTree)(blobs);
      setDocuments(newDocuments);

      // Preserve selection by finding the same documents in the new tree
      if (selectedRows.length > 0 && !isUpdatingSelectionRef.current) {
        var selectedIds = new Set(selectedRows.map(function (r) {
          return r.id;
        }));
        var updatedSelection = newDocuments.filter(function (doc) {
          return selectedIds.has(doc.id);
        });
        if (updatedSelection.length !== selectedRows.length) {
          isUpdatingSelectionRef.current = true;
          setSelectedRows(updatedSelection);
          // Reset flag after state update
          globalThis.setTimeout(function () {
            isUpdatingSelectionRef.current = false;
          }, 0);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blobs]);
  var getFileInfo = function getFileInfo(files) {
    var response = {
      fileName: undefined,
      fileType: "zip"
    };
    if (files.length === 1 && files[0].fileType !== _constants.TYPE_FOLDER) {
      response.fileName = files[0].documentName;
      response.fileType = files[0].file_extension;
    }
    return response;
  };
  var filterOnlyUserSelected = function filterOnlyUserSelected() {
    var toRemove = [];
    var filteredSelected = [];
    // Filter selected rows to avoid duplicates when folders and their children are both selected
    var _iterator = _createForOfIteratorHelper(selectedRows),
      _step;
    try {
      var _loop = function _loop() {
        var selectedRow = _step.value;
        if (toRemove.some(function (sR) {
          return sR.id === selectedRow.id;
        })) {
          return 1; // continue
        }
        filteredSelected.push(selectedRow);
        // If this is a folder, keep it
        if (selectedRow.fileType === _constants.TYPE_FOLDER) {
          //Delete all the childs
          var descendants = _removeDescendant(selectedRow);
          toRemove.push.apply(toRemove, _toConsumableArray(descendants));
          //Remove all the ascendant hierarchy
          var traversed = removeTraverse(selectedRow);
          toRemove.push.apply(toRemove, _toConsumableArray(traversed));
        } else if (selectedRow.fileType !== _constants.TYPE_FOLDER) {
          // If this is a file, check if any of its parent folders are also selected
          // We need to traverse up the hierarchy to see if any parent folder is selected
          var _traversed = removeTraverse(selectedRow);
          toRemove.push.apply(toRemove, _toConsumableArray(_traversed));
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        if (_loop()) continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return filteredSelected;
  };
  var createAndDownloadZip = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var selectedFiles, _yield$downloadBlobs, data, _getFileInfo, fileName, fileType;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setDownloadLoading(true);
            if (!blobs) {
              _context.next = 16;
              break;
            }
            _context.prev = 2;
            selectedFiles = filterOnlyUserSelected();
            _context.next = 6;
            return downloadBlobs({
              blob_names: getNonFolderItems(selectedFiles).map(function (f) {
                return {
                  name: f.documentName,
                  uuid: f.uuid
                };
              }),
              folder_path: selectedFiles.filter(function (f) {
                return f.fileType === _constants.TYPE_FOLDER;
              }).map(function (f) {
                return f.path;
              })
            });
          case 6:
            _yield$downloadBlobs = _context.sent;
            data = _yield$downloadBlobs.data;
            _getFileInfo = getFileInfo(selectedFiles), fileName = _getFileInfo.fileName, fileType = _getFileInfo.fileType;
            (0, _DocumentGrid.performDownload)(data, fileType, fileName);
            _context.next = 16;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](2);
            setDownloadLoading(false);
            return _context.abrupt("return", false);
          case 16:
            setDownloadLoading(false);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 12]]);
    }));
    return function createAndDownloadZip() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleDownloadFile = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _yield$downloadBlobs2, data, _getFileInfo2, fileName, fileType;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setDownloadFromGridLoading(true);
            if (!selectedDocument) {
              _context2.next = 15;
              break;
            }
            _context2.prev = 2;
            _context2.next = 5;
            return downloadBlobs({
              blob_names: selectedDocument.fileType === _constants.TYPE_FOLDER ? [] : [{
                name: selectedDocument.documentName,
                uuid: selectedDocument.uuid
              }],
              folder_path: selectedDocument.fileType === _constants.TYPE_FOLDER ? [selectedDocument.path] : []
            });
          case 5:
            _yield$downloadBlobs2 = _context2.sent;
            data = _yield$downloadBlobs2.data;
            _getFileInfo2 = getFileInfo([selectedDocument]), fileName = _getFileInfo2.fileName, fileType = _getFileInfo2.fileType;
            (0, _DocumentGrid.performDownload)(data, fileType, fileName);
            _context2.next = 15;
            break;
          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](2);
            setDownloadFromGridLoading(false);
            return _context2.abrupt("return", false);
          case 15:
            setDownloadFromGridLoading(false);
          case 16:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 11]]);
    }));
    return function handleDownloadFile() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleColumnNameClick = function handleColumnNameClick(blob) {
    if (blob.fileType == _constants.TYPE_FOLDER) {
      //Just add information to the breadcrumb
      setSelectedPath([].concat(_toConsumableArray(selectedPath), [{
        id: blob.id,
        name: blob.documentName
      }]));
    } else {
      setLocalStorage(blob);
    }
  };
  (0, _react.useEffect)(function () {
    if (selectedPath.length === 0) {
      setParentId(null);
    } else {
      var pathLength = selectedPath.length;
      setParentId(selectedPath[pathLength - 1].id);
    }
  }, [selectedPath]);
  var handleCustomGridSelectionChange = (0, _react.useCallback)(function (selectedRowsFromGrid) {
    // Skip if we're updating selection internally
    if (isUpdatingSelectionRef.current) {
      return;
    }

    // Only update if the selection has actually changed - use IDs for comparison
    var newIds = new Set(selectedRowsFromGrid.map(function (r) {
      return r.id;
    }));
    var currentIds = new Set(selectedRows.map(function (r) {
      return r.id;
    }));

    // Check if sets are equal (same size and all elements match)
    var hasChanged = newIds.size !== currentIds.size || !_toConsumableArray(newIds).every(function (id) {
      return currentIds.has(id);
    });
    if (hasChanged) {
      setSelectedRows(selectedRowsFromGrid);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [selectedRows, selectedPath]);
  var removeTraverse = function removeTraverse(selectedRow) {
    var toRemove = [];
    if (selectedRow.parentId) {
      var currentId = selectedRow.parentId;
      //We need to add all the ascendant hirerachy to remove
      while (currentId) {
        var found = selectedRows.find(function (rowParent) {
          return rowParent.id === currentId;
        });
        if (found) {
          toRemove.push(found);
          currentId = found.parentId;
        } else {
          currentId = null;
        }
      }
    }
    return toRemove;
  };
  var _removeDescendant = function removeDescendant(selectedRow) {
    var toRemove = [];
    var _iterator2 = _createForOfIteratorHelper(selectedRows),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var childRow = _step2.value;
        if (childRow.parentId === selectedRow.id) {
          if (childRow.fileType === _constants.TYPE_FOLDER) {
            toRemove.push.apply(toRemove, _toConsumableArray(_removeDescendant(childRow)));
          }
          toRemove.push(childRow);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return toRemove;
  };
  var getColumns = function getColumns() {
    var toReturn = columns;
    if (hasAnyPermission([_policies.Permission.FOLDER_ACTION_RENAME, _policies.Permission.FOLDER_ACTION_DOWNLOAD, _policies.Permission.FOLDER_ACTION_MOVE_TO, _policies.Permission.FOLDER_ACTION_DELETE, _policies.Permission.FILE_ACTION_EDIT, _policies.Permission.FILE_ACTION_UPDATE_VERSION, _policies.Permission.FILE_ACTION_DOWNLOAD, _policies.Permission.FILE_ACTION_MOVE_TO, _policies.Permission.FILE_ACTION_DELETE])) {
      toReturn.push({
        field: "actions",
        headerName: "Actions",
        flex: 0.5,
        renderCell: function renderCell(params) {
          var composedId = "Id-".concat(params.row.id);
          var isSelected = selectedButtonId === params.id;
          var moveToFolderItem = /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            onClick: function onClick() {
              callbackMoveFiles([params.row]);
            },
            "data-testid": "open_moveFolder"
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Move to folder"));
          return /*#__PURE__*/_react["default"].createElement(_material.Box, {
            className: "action_menu",
            style: {
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              width: "100%"
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            "data-testid": "menu_trigger-".concat(params.row.id),
            id: composedId,
            onClick: function onClick(event) {
              setAnchorEl(event.currentTarget);
              setSelectedDocument(params.row);
              setSelectedButtonId(params.id);
            },
            style: {
              backgroundColor: isSelected ? theme.palette.primary.main : "transparent",
              borderRadius: "5px",
              width: "30px",
              height: "30px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0"
            }
          }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
            icon: "iconamoon:menu-kebab-vertical-bold",
            width: "25",
            height: "25",
            color: isSelected ? "white" : theme.palette.primary.main
          })), /*#__PURE__*/_react["default"].createElement(_material.Menu, {
            id: "basic-menu",
            anchorEl: anchorEl,
            open: (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.id) === composedId,
            onClose: function onClose() {
              setAnchorEl(null);
              setSelectedButtonId(null);
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left"
            },
            slotProps: {
              paper: {
                "aria-labelledby": "basic-button"
              }
            },
            sx: {
              "& .MuiPaper-root": {
                boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
                borderRadius: "0px",
                transform: "translateX(30px)"
              }
            }
          }, params.row.fileType === _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasPermission(_policies.Permission.FOLDER_ACTION_RENAME) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "open_renameFolder",
            onClick: function onClick() {
              if (selectedDocument !== null) {
                callbackEditFile(selectedDocument);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Rename folder")), hasPermission(_policies.Permission.FOLDER_ACTION_DOWNLOAD) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "download_folder",
            onClick: handleDownloadFile,
            disabled: downloadFromGridLoading
          }, downloadFromGridLoading && /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
            size: 15
          }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, downloadFromGridLoading ? "Downloading" : "Download folder", " ")), hasPermission(_policies.Permission.FOLDER_ACTION_MOVE_TO) && moveToFolderItem, hasPermission(_policies.Permission.FOLDER_ACTION_DELETE) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "delete_folder",
            onClick: function onClick() {
              if (selectedDocument) {
                var filesTodelete = getNonFolderItems((0, _DocumentGrid.getDocumentsWithChildren)([selectedDocument.id], documents));
                callbackDeleteFile(filesTodelete);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Delete folder"))), params.row.fileType !== _constants.TYPE_FOLDER && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasPermission(_policies.Permission.FILE_ACTION_EDIT) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "open_modalEdit",
            onClick: function onClick() {
              if (selectedDocument !== null) {
                callbackEditFile(selectedDocument);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Edit")), hasPermission(_policies.Permission.FILE_ACTION_UPDATE_VERSION) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "open_modalOverride",
            onClick: function onClick() {
              if (selectedDocument !== null) {
                callbackOverrideFile(selectedDocument);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Update file version")), hasPermission(_policies.Permission.FILE_ACTION_DOWNLOAD) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "downloadButton",
            onClick: handleDownloadFile,
            disabled: downloadFromGridLoading
          }, downloadFromGridLoading && /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
            size: 15
          }), /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, downloadFromGridLoading ? "Downloading" : "Download file", " ")), hasPermission(_policies.Permission.FILE_ACTION_MOVE_TO) && moveToFolderItem, hasPermission(_policies.Permission.FILE_ACTION_DELETE) && /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
            "data-testid": "delete_btn",
            onClick: function onClick() {
              if (selectedDocument) {
                callbackDeleteFile([selectedDocument]);
              }
            }
          }, /*#__PURE__*/_react["default"].createElement(_material.ListItemText, null, "Delete file")))));
        }
      });
    }
    return toReturn;
  };
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex flow-column",
    p: 3,
    "data-testid": "documentGrid"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex",
    justifyContent: "space-between",
    mb: 3
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "search-bar-container"
  }, /*#__PURE__*/_react["default"].createElement(_SearchField["default"], {
    searchText: searchText,
    setSearchText: setSearchText
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex menu_items"
  }, /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Clear filters applied to the Grid"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn-default btn-default-style",
    onClick: function onClick() {
      if (gridRef !== null && gridRef !== void 0 && gridRef.current) {
        gridRef.current.clearAllSortFilters();
      }
    },
    "data-testid": "clearFilters",
    style: {
      color: theme.palette.primary.main
    }
  }, "Clear all filters"))), hasPermission(_policies.Permission.DOWNLOAD) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Download selected files/folders"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "menu_btn menu_btn_download",
    disabled: selectedRows.length === 0 || downloadLoading,
    onClick: createAndDownloadZip,
    "data-testid": "download_btn"
  }, downloadLoading ? /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, {
    size: 15
  }) : /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "material-symbols:download",
    width: 24
  }))))), hasPermission(_policies.Permission.MOVE_TO_FOLDER) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Move selected files/folders"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "menu_btn menu_btn_move",
    onClick: function onClick() {
      var filteredSelected = filterOnlyUserSelected();
      callbackMoveFiles(documents.filter(function (row) {
        return filteredSelected.find(function (sR) {
          return sR.id === row.id;
        });
      }));
    },
    disabled: selectedRows.length === 0,
    "data-testid": "moveButton"
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "tdesign:folder-move",
    width: 24
  })))), hasPermission(_policies.Permission.DELETE) && /*#__PURE__*/_react["default"].createElement(_material.Tooltip, {
    arrow: true,
    title: "Delete selected files/folders"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "menu_btn menu_btn_delete",
    onClick: function onClick() {
      if (blobs) {
        callbackDeleteFile(getNonFolderItems(selectedRows));
      }
    },
    "data-testid": "deleteButton",
    disabled: selectedRows.length === 0
  }, /*#__PURE__*/_react["default"].createElement(_react2.Icon, {
    icon: "material-symbols:delete-outline-rounded",
    width: 24
  })))), hasPermission(_policies.Permission.ADD_FOLDER) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackAddFiles("create_folder");
    },
    disabled: selectedRows.length >= 1,
    className: "upload_btn",
    "data-testid": "createFolderButton"
  }, "Add folder")), hasPermission(_policies.Permission.UPLOAD_FILES) && /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return callbackAddFiles("upload_file");
    },
    disabled: selectedRows.length >= 1,
    className: "upload_btn",
    "data-testid": "uploadFileButton"
  }, "Upload files"))), /*#__PURE__*/_react["default"].createElement(_DocumentGridBreadcrumb["default"], {
    breadcrumbs: selectedPath,
    clickOnPathCallback: setSelectedPath
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex grid-body-content",
    sx: {
      height: "calc(100vh - 383px)"
    }
  }, /*#__PURE__*/_react["default"].createElement(_CustomGrid["default"], {
    ref: gridRef,
    style: {
      maxHeight: "60vh",
      minHeight: "505px",
      width: "70vw",
      overflow: "visible"
    },
    rows: gridRows,
    loading: isDocumentsLoading,
    columns: getColumns(),
    onSelectionChange: handleCustomGridSelectionChange,
    initialSelectedRowIds: selectedRows.map(function (r) {
      return r.id;
    }),
    initialExplicitlyDeselectedIds: hiddenItemIds,
    allRows: documents,
    keepNonExistentRowsSelected: true,
    pageSizeOptions: [5, 10, 50, 100],
    checkboxSelection: hasPermission(_policies.Permission.CHECKBOXES),
    disableRowSelectionOnClick: true,
    classes: {
      footerContainer: selectedRows.length > 0 ? "custom-footer" : "footer"
    }
  }), selectedRows.length > 0 && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex flow-column selected-side",
    "data-testid": "selectedFiles"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "selected-side-header"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "Selected files")), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "flex flow-column gap-5 selected-side-content"
  }, /*#__PURE__*/_react["default"].createElement(_DocumentsGridSelected["default"], {
    selectedRows: selectedRows.map(function (r) {
      return r.id;
    }),
    allRows: documents,
    callbackSetSelectedRows: function callbackSetSelectedRows(idsToRemove) {
      setSelectedRows(selectedRows.filter(function (r) {
        return !idsToRemove.includes(r.id);
      }));
    },
    onHiddenItemsChange: function onHiddenItemsChange(hiddenIds) {
      setHiddenItemIds(hiddenIds);
    }
  }), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: "reset_btn_container"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    onClick: function onClick() {
      return setSelectedRows([]);
    },
    className: "clear_btn_manag"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Clear")))))));
};
var _default = exports["default"] = DocumentsGrid;